module.exports = __webpack_public_path__ + "img/artificial-intelligence.52484cf9.png";